//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  apiUrl,
} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
  name: 'demurrageQueryList',
  components: {
    MyBtnReturn
  },
  data() {
    return {
      shipper: null,
      companyId: null,

      listData: []
    }
  },
  created() {
    document.title = '滞期天数查询'
    this.shipper = this.$route.query.shipper;
    this.companyId = this.$route.query.companyId;
    this.getData()
  },
  methods: {
    getData() {
      let data = {
        shipper: this.shipper,
        companyId: this.companyId
      }

      this.$http.post(apiUrl.getContainerDemurrageDaysList, data)
      .then((response) => {
        if (response.data.code == 200) {
          this.listData = response.data.data
        }
      })
      .catch((error) => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/kehu/demurrageQuery/demurrageQueryList.vue